module.exports = [{"code":1,"name":"危险品车"},{"code":2,"name":"货车"},{"code":3,"name":"客车"},{"code":4,"name":"小轿车"}]


//////////////////
// WEBPACK FOOTER
// ./static/json/dictionary/vehicleType.json
// module id = wPxD
// module chunks = 11